import * as React from 'react'

import { FeatureFlagAvailabilitiesDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'
import { buildModuleRoute } from 'modules/core/lib/react-router'

const InboxPage = React.lazy(() => import('modules/notifications/pages/InboxPage'))
const TodoTasksPage = React.lazy(() => import('modules/inbox_tasks/pages/TodoTasks'))
const CompletedTasksPage = React.lazy(() => import('modules/inbox_tasks/pages/CompletedTasks'))
const NotificationsSettingsPage = React.lazy(
  () => import('modules/notifications/pages/NotificationsSettingsPage')
)
const RedirectPage = React.lazy(() => import('modules/notifications/pages/RedirectPage'))
const RequestsPage = React.lazy(() => import('modules/notifications/pages/RequestsPage'))
const RootPage = React.lazy(() => import('modules/notifications/pages/RootPage'))

export const inboxRoutes: NavigationRoutesFn = (navigation) => [
  buildModuleRoute({
    path: navigation.inbox.path,
    element: <RootPage />,
    handle: {
      module: 'notifications',
      moduleName: () => i18n.t('sidebar.inbox'),
      meta: ({ watchQuery, session }) =>
        watchQuery({
          query: FeatureFlagAvailabilitiesDocument,
          variables: {
            companyId: session.company.id,
            featureNames: ['enable_new_inbox', 'enable_requests_tab'],
          },
        }).map(({ data }) => {
          const newInboxEnabled = data?.features?.featuresConnection?.nodes?.some(
            (node) => node.name === 'enable_new_inbox' && node.enabled
          )
          const requestsTabEnabled = data?.features?.featuresConnection?.nodes?.some(
            (node) => node.name === 'enable_requests_tab' && node.enabled
          )

          return {
            title: i18n.t('sidebar.inbox'),
            subNavigation: [
              ...(newInboxEnabled
                ? [
                    {
                      title: i18n.t('common.todo'),
                      href: navigation.inbox.todo.fullPath(),
                    },
                    {
                      title: i18n.t('tasks.new_statuses.completed'),
                      href: navigation.inbox.completed.fullPath(),
                    },
                  ]
                : []),
              ...(!newInboxEnabled || requestsTabEnabled
                ? [
                    {
                      title: i18n.t('notifications.inbox.requests.title.none'),
                      href: navigation.inbox.requests.fullPath(),
                    },
                  ]
                : []),
            ],
          }
        }),
    },
    children: [
      {
        path: '',
        element: <InboxPage />,
        children: [
          {
            index: true,
            element: <RedirectPage />,
          },
          {
            path: navigation.inbox.todo.path,
            element: <TodoTasksPage />,
          },
          {
            path: navigation.inbox.completed.path,
            element: <CompletedTasksPage />,
          },
          {
            path: navigation.inbox.requests.path,
            element: <RequestsPage />,
          },
        ],
      },
      {
        path: navigation.inbox.settings.path,
        element: <NotificationsSettingsPage />,
        handle: {
          meta: () => ({
            title: i18n.t('sidebar.notifications_settings'),
          }),
        },
      },
    ],
  }),
]
